import React from 'react';
import { Grid, CircularProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// import { useTheme } from '@mui/material/styles';
// import CircularProgress from '@material-ui/core/CircularProgress';
// import Grid from '@material-ui/core/Grid';
// import { makeStyles } from '@material-ui/core/styles';

export function Loading(props) {
  const theme = useTheme();
  // eslint-disable-next-line react/prop-types
  const { centered } = props;
  if (centered) {
    return (
      <Grid
        container
        alignItems="center"
        justify="center"
        direction="column"
        sx={{
          padding: theme.spacing(3, 2),
          height: 300,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }}
      >
        <Grid item>
          <CircularProgress {...props} />
        </Grid>
      </Grid>
    );
  }
  return <CircularProgress {...props} />;
}
